import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.AUTHENTICATION.SET_SESSION_REQUEST,
  payload,
})
